<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      border="default"
      cell-class-name="align-top"
      row-id="amzSampleCode"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        checkMethod: ({ row }) =>
          row.amzSampleStatus && ['Y'].includes(row.amzSampleStatus),
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span v-if="row.amzSpuNo">SPU:</span
        ><span style="color: #409eff">{{ row.amzSpuNo }}</span>
      </template>
      <template v-slot:goodsSize="{ row }">
        <div v-html="row.goodsSize"></div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzSampleStatus === 'D'
              ? 'danger'
              : row.amzSampleStatus === 'N'
              ? 'light'
              : row.amzSampleStatus === 'T'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_amzSampleStatus }}
        </el-tag>
      </template>

      <template v-slot:displayBrand="{ row }">
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.amzSampleNo }}</span>
        <br />
      </template>
      <template v-slot:displayScm="{ row }">
        <span>{{ row.scmName }}</span>
        <br />
        <span>{{ row.scmSampleNo }}</span>
        <br />
      </template>
      <template v-slot:designAndBuyer="{ row }">
        <span>{{ $l('table_label_PM') || 'PM' }} ：</span
        ><span style="color: #303133">{{ row.designName }}</span>
        <br />
        <span>{{ $l('table_label_PC') || 'PC' }}：</span
        ><span style="color: #303133">{{ row.buyerName }}</span>
      </template>

      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          fit="cover"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      const { amzSampleCode, amzSampleNo } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { amzSampleCode },
            query: { amzSampleNo },
          })
          break
        case 'delete':
          this.del(amzSampleCode)
          break
        case 'review':
          this.review(amzSampleCode)
          break
        case 'stop':
          this.stop(amzSampleCode)
          break
        case 'shelve':
          this.shelve(amzSampleCode)
          break
        case 'copy':
          this.copy(amzSampleCode)
          break
        case 'print':
          this.print(amzSampleCode, amzSampleNo)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    print(amzSampleCode, amzSampleNo) {
      const codes = [amzSampleCode]
      if (!codes?.length) {
        this.$message({
          showClose: true,
          message: '请选择需要打印的样品',
          type: 'warning',
        })
        return
      }
      let data = {
        codes,
      }
      let fileName = `AMZ样品标签_${amzSampleNo}_`
      this.$api.globalExportData('/ecom/amz/sample/print', data, fileName)
    },
    copy(amzSampleCode) {
      this.$confirm(
        this.$l('INDEX.tips_copy') || '是否要复制该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (this.loadingOpen()) return
        this.$api
          .ecomAmzSampleCopyApi({ amzSampleCode })
          .then((res) => {
            const { amzSampleCode, amzSampleNo } = res.body || {}
            this.$emit('reload')
            this.loadingClose()
            this.$emit('openEditPage', {
              pageType: 'edit',
              params: { amzSampleCode },
              query: { amzSampleNo },
            })
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    shelve(amzSampleCode) {
      this.$emit('onShelve', [amzSampleCode])
    },
    del(amzSampleCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomAmzSampleDelApi({ amzSampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    review(amzSampleCode) {
      this.$confirm(
        this.$l('INDEX.tips_review') || '是否要审核该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomAmzSampleReviewApi({ amzSampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_review_ok') || '审核成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    stop(amzSampleCode) {
      this.$confirm(
        this.$l('tips_stop') || '是否要停用该样品信息？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.ecomAmzSampleStopApi({ amzSampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('tips_stop_ok') || '停用成功！',
            type: 'success',
          })
          this.$emit('reload')
          this.clearCheckboxRow()
        })
      })
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'defaultImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
